import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";
import type { Me } from "../api/types";
import { identify } from "./alerts";

/** The authenticated caller (id, email, superadmin flag). Cached for the
 * session — it gates the Activity dashboard nav + route. */
export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: () => api<Me>("/api/me").then((me) => { identify(me.id); return me; }),
    staleTime: Infinity,
  });
}
